// extracted by mini-css-extract-plugin
export default {"noData":"emp_src-emp-3-0-components-Sankey-index__noData--w18fk","empSankeySpin":"emp_src-emp-3-0-components-Sankey-index__empSankeySpin--rA1P_"};